// gapcursor/index.ts
export * from "prosemirror-gapcursor";
